module.exports = __webpack_public_path__ + "static/media/banner-radar.c22513cb.png";